/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const loginInputDataSchema = z.object({
	email: z.string(),
	password: z.string(),
})

export type LoginInputDataSchema = z.infer<typeof loginInputDataSchema>
